'use client';

import { useEffect } from 'react';

const appStartTime = new Date();
const RELOAD_FLAG = 'chunk-error-reloaded';

export default function ChunkErrorDiagnostic() {
  useEffect(() => {
    function handleError(event: ErrorEvent) {
      const error = event.error;
      if (!error || error.name !== 'ChunkLoadError') return;

      const now = new Date();
      const elapsedMs = now.getTime() - appStartTime.getTime();
      const elapsedMinutes = Math.floor(elapsedMs / 60000);
      const elapsedHours = (elapsedMs / 3600000).toFixed(2);

      const chunkUrlMatch = error.message?.match(/(https?:\/\/[^\s)]+)/);
      const failedChunkUrl = chunkUrlMatch?.[1] ?? 'unknown';

      const diagnosticInfo = {
        name: error.name,
        message: error.message,
        pathname: window.location.pathname,
        appStartedAt: appStartTime.toISOString(),
        errorOccurredAt: now.toISOString(),
        elapsed: `${elapsedMinutes}min (${elapsedHours}h)`,
        failedChunkUrl,
      };

      console.error('[ChunkLoadError Debug]', diagnosticInfo);

      // 1회만 자동 reload (무한루프 방지)
      const alreadyReloaded = sessionStorage.getItem(RELOAD_FLAG);
      if (!alreadyReloaded) {
        sessionStorage.setItem(RELOAD_FLAG, 'true');
        window.location.reload();
      }
      // 이미 reload 했는데도 또 실패 → 로그만 남김 (CDN/서버 문제)
    }

    // reload 성공 시 플래그 제거 (다음 에러에 대비)
    if (sessionStorage.getItem(RELOAD_FLAG)) {
      sessionStorage.removeItem(RELOAD_FLAG);
    }

    window.addEventListener('error', handleError);
    return () => window.removeEventListener('error', handleError);
  }, []);

  return null;
}
